import { isAfter, subHours } from 'date-fns';
import { ProgressionModel } from 'features/wildfires/wildfire.types';
import { useProgressionModelsEnabled } from '../../features/wildfires/hooks/useProgressionModelsEnabled';

type UseShowNewProgressionModelAlertProps = {
  progressionModels: ProgressionModel[];
};

type UseShowNewProgressionModelAlert = {
  showNewProgressionModelAlert: boolean;
  progressionModelLastUpdated?: Date;
};

export const useShowNewProgressionModelAlert = (
  props: UseShowNewProgressionModelAlertProps,
): UseShowNewProgressionModelAlert => {
  const { progressionModels } = props;
  const showProgressionModels = useProgressionModelsEnabled();

  if (!showProgressionModels || !progressionModels.length) {
    return { showNewProgressionModelAlert: false };
  }

  const modelsSorted = [...progressionModels].sort(
    (a, b) =>
      new Date(b.dateModified).getTime() - new Date(a.dateModified).getTime(),
  );

  const mostRecentModelDateModified = modelsSorted[0]?.dateModified;

  const isRecentlyUpdated = mostRecentModelDateModified
    ? isAfter(mostRecentModelDateModified, subHours(new Date(), 1))
    : false;

  return {
    showNewProgressionModelAlert: isRecentlyUpdated,
    progressionModelLastUpdated: mostRecentModelDateModified,
  };
};
